import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(fullName: string): string {
    return fullName
      .split(' ')
      .map((n) => n.charAt(0))
      .join('')
      .substring(0, 2);
  }
}
